import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=e2c335a4&"
import script from "./VTag.vue?vue&type=script&lang=ts&"
export * from "./VTag.vue?vue&type=script&lang=ts&"
import style0 from "./VTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports